export const getCountdownDate = ({
  offerUntil,
  courseLaunchDate,
}: {
  offerUntil?: string;
  courseLaunchDate?: Date;
}) => {
  const now = new Date();
  let futureDate = new Date();
  if (offerUntil === 'midnight') {
    futureDate.setHours(23, 59, 59);
  } else if (offerUntil === 'tomorrow') {
    futureDate.setHours(23, 59, 59);
    futureDate.setDate(now.getDate() + 1);
  } else if (offerUntil === 'next') {
    futureDate.setHours(23, 59, 59);
    futureDate.setDate(now.getDate() + 2);
  } else if (offerUntil) {
    try {
      futureDate = new Date(offerUntil);
    } catch (e) {
      console.warn(`Invalid date: ${e}`);
    }
  }
  if (courseLaunchDate) futureDate = courseLaunchDate;
  return futureDate;
};
